import React, { useEffect, useMemo } from "react";
import { ConsultationFormWidget } from "../../Components/ConsultationFormWidget";
import { useLocation } from "react-router-dom";
import {
  requestListConsultationByUser,
  requestListService,
  useAuthState,
  useConsultationDispatch,
  useConsultationState,
} from "../../Context";
import useEmbedTheme from "../../Hooks/useEmbedTheme";

const ConsultationFormEmbed = () => {
  const consultationDispatch = useConsultationDispatch();
  const { consultations, serviceLoading, services } = useConsultationState();

  const { user } = useAuthState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const guestID = searchParams.get("id");
  const guestClient = searchParams.get("client");

  const theme = useEmbedTheme();

  useEffect(() => {
    if (services.length === 0 && !serviceLoading) {
      requestListService(consultationDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.id) {
      requestListConsultationByUser(consultationDispatch, {
        userID: user.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const firstOngoingConsultation = useMemo(() => {
    return consultations.find(
      (consultation) => consultation.status === "ONGOING",
    );
  }, [consultations]);

  return (
    <div className="min-h-screen p-4" style={{ backgroundColor: theme.background }}>
      {firstOngoingConsultation && Boolean(user?.id) && (
        <div
          className="mb-4 p-4 rounded-lg border"
          style={{ backgroundColor: theme.primaryLight, borderColor: theme.accent }}
        >
          <a
            href={`/embed/consultation/${firstOngoingConsultation.id}${guestClient ? `?client=${encodeURIComponent(guestClient)}` : ""}`}
            className="flex items-center gap-2 text-sm font-medium hover:underline"
            style={{ color: theme.accentText }}
          >
            <span>{firstOngoingConsultation?.category?.name}</span>
            <span>—</span>
            <span>{firstOngoingConsultation?.consultant?.user?.name}</span>
            <span
              className="ml-auto text-xs px-2 py-0.5 rounded-full border"
              style={{ backgroundColor: theme.primaryLight, borderColor: theme.accent, color: theme.accentText }}
            >
              Ongoing
            </span>
          </a>
        </div>
      )}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <ConsultationFormWidget
          categories={services}
          loading={serviceLoading}
          withConsultantButton={false}
          withAddOns={false}
          guest
          guestID={guestID}
          guestClient={guestClient}
          embedMode
          theme={theme}
        />
      </div>
    </div>
  );
};

export default ConsultationFormEmbed;
